<script lang="ts">
  import Restart from '~icons/mdi/restart';
  import ActionButton from '~/components/ActionButton.svelte';
  import { ClassicGame } from '~/store/classic.svelte';
  import { setGame } from '~/store/GameContext.svelte';

  const { iconOnly = false } = $props();
  const set = setGame();

  const handlePlayClassic = async (e: MouseEvent) => {
    e.stopPropagation();
    set(await ClassicGame.load());
  };
</script>

<ActionButton {iconOnly} onClick={handlePlayClassic}>
  <Restart color="#36AE7C" size="1em" />
  New Game
</ActionButton>
